/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { registerDecorator } from 'class-validator';
export function IsBeforeOrToday(validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: 'isBeforeOrToday',
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: {
                validate(propertyValue) {
                    return new Date(propertyValue).valueOf() <= new Date().valueOf();
                },
                defaultMessage(args) {
                    return `"${args.property}" must be before or today`;
                }
            }
        });
    };
}
//# sourceMappingURL=is-before-now.js.map